import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.view.html',
  styleUrls: ['./privacy-policy.view.scss']
})
export class PrivacyPolicy implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
